export default "__VITE_ASSET__DeNAcN_d__"